<template lang="html">
  <div class="empty-note">
    <h1 :class="[fontSize]" ref="content">{{displayText}}<span class="cursor"><wbr />|</span></h1>
    <footer>
      <span class="date">{{currentDate}}</span>
      <Icon icon="add-emotion" />
    </footer>
  </div>
</template>

<script>
import { Date as SugarDate } from 'sugar-date';

import WelcomeMessages from '@/assets/WelcomeMessages';

import Icon from './Icon.vue';

export default {
  beforeDestroy() {
    window.cancelAnimationFrame(this.animationFrame);
  },
  components: {
    Icon,
  },
  computed: {
    currentDate() {
      return new SugarDate().format('{HH}:{mm}, {dd}. {Month} {yyyy}');
    },
  },
  data() {
    return {
      animationFrame: null,
      cleared: true,
      deleteDelay: 15,
      displayText: '',
      fontSize: 'normal',
      lastFrameTime: 0,
      letterCache: [],
      typeDelay: 75,
    };
  },
  methods: {
    animate() {
      const now = Date.now();
      const delta = now - this.lastFrameTime;

      if (this.displayText === this.message) return;

      this.animationFrame = window.requestAnimationFrame(this.animate);

      let delay = 0;

      if (this.cleared) delay = this.typeDelay;
      else delay = this.deleteDelay;

      if (delta <= delay) return;

      if (!this.cleared) {
        if (this.displayText.length > 0) this.displayText = this.displayText.substr(0, this.displayText.length - 1);
        else {
          this.cleared = true;
          this.fontSize = 'normal';
          return;
        }
      }

      if (this.cleared) {
        this.displayText += this.letterCache.shift();
        if (this.$refs.content.scrollHeight > this.$refs.content.clientHeight) this.fontSize = 'small';
      }

      this.lastFrameTime = now;
    },
  },
  mounted() {
    this.letterCache = this.message.split('');
    this.animate();
  },
  props: {
    message: {
      type: String,
      default() {
        const now = new Date();
        const hour = now.getHours();
        const availableMessages = WelcomeMessages.filter((message) => {
          if (message.min < message.max) return hour >= message.min && hour <= message.max;
          let { min } = message;
          const hourRange = [min];
          while (min < 23) hourRange.push(min += 1);
          min = -1;
          while (min < message.max) hourRange.push(min += 1);
          return hourRange.includes(hour);
        });
        const index = Math.floor(Math.random() * availableMessages.length);
        const message = availableMessages[index].message.replace(/\$\{name\}/g, this.$store.state.user.name);
        return message;
      },
    },
  },
  watch: {
    message(newVal) {
      window.cancelAnimationFrame(this.animationFrame);
      this.letterCache = newVal.split('');
      this.cleared = false;
      this.animate();
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '../styles/colors'

.empty-note
  border: 2px dashed $text
  border-radius: 12px
  display: flex
  flex-direction: column
  width: 294px
  height: 324px
  padding: 16px
  margin: 0 auto
  opacity: 0.38

  h1
    margin: 0
    font-size: 2rem
    font-weight: 600
    line-height: 1.35
    height: calc(100% - 48px)
    overflow: visible

    &.small
      font-size: 1.5rem

    .cursor
      margin-left: 1px
      animation: blink 1s infinite

      @keyframes blink
        0%
          opacity: 0
        50%
          opacity: 1
        100%
          opacity: 0

  footer
    margin-top: auto
    display: flex
    justify-content: space-between
    align-items: center

    .date
      font-size: 0.75rem
      font-weight: normal

    .icon
      opacity: 0.38
</style>
